export default "__VITE_ASSET__CaTCw7Wd__"